import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import SuccessGuarantee from '../components/SuccessGuarantee';
import PricingPackages from '../components/PricingPackages';
import BookingSystem from '../components/BookingSystem';
import Gallery from '../components/Gallery';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppBooking from '../components/WhatsAppBooking';
import AdminModal from '../components/AdminModal';
import AdminPanel from '../components/AdminPanel';
import LanguageSelector from '../components/LanguageSelector';
import { translations } from '../data/translations';

const HomePage = () => {
  const [language, setLanguage] = useState('en');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navigate = useNavigate();

  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'services', 'guarantee', 'pricing', 'booking', 'gallery', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = useCallback((sectionId) => {
    if (sectionId === 'booking-page') {
      navigate('/bookings');
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [navigate]);

  // Handle URL hash navigation
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        scrollToSection(hash);
      }, 100);
    }
  }, [scrollToSection]);

  const handleAdminLogin = (password) => {
    if (password === 'kanaihyaSpeedy') {
      setIsAdmin(true);
      setShowAdminModal(false);
      return true;
    }
    return false;
  };

  const handleAdminLogout = () => {
    setIsAdmin(false);
    scrollToSection('home');
  };

  if (isAdmin) {
    return (
      <AdminPanel t={t} onLogout={handleAdminLogout} />
    );
  }

  return (
    <div className="App">
        <Navbar 
          t={t} 
          activeSection={activeSection}
          scrollToSection={scrollToSection}
        />
        
        <main>
          <Hero t={t} />
          <About t={t} />
          <Services t={t} />
          <SuccessGuarantee t={t} />
          <PricingPackages t={t} />
          <BookingSystem t={t} />
          <Gallery t={t} />
          <Contact t={t} />
        </main>
        
        {/* WhatsApp Floating Widget */}
        <WhatsAppBooking t={t} />
        
        {/* Language Selector */}
        <LanguageSelector 
          language={language} 
          setLanguage={setLanguage} 
        />
        
        <Footer 
          t={t} 
          scrollToSection={scrollToSection}
          onAdminClick={() => setShowAdminModal(true)}
        />
        
        <AdminModal
          show={showAdminModal}
          onHide={() => setShowAdminModal(false)}
          onLogin={handleAdminLogin}
          t={t}
        />
      </div>
    );
};

export default HomePage;